<template>
  <div id="contenedor-listado-anticipos-contrato-mobile">
    <template v-for="(anticipo, index) in listadoAnticipos">
      <template>
        <v-card :key="index" class="mb-3">
          <v-card-title class="secondary--text font-weight-bold">
            <!-- {{ new Date(`${anticipo.fecha} 00:00:0`).toLocaleDateString() }} -->
            {{ $moment(anticipo.fecha).format('DD/MM/YYYY') }}
          </v-card-title>
          <v-card-text>
              <v-col cols="12" class="py-2">
                <v-row justify="space-between" align="center">
                  <span class="secondary--text font-weight-bold" cols="12">
                    Porcentaje de anticipo:
                  </span>
                  <v-chip color="info">
                      {{ `${anticipo.porcentaje} %` }}
                  </v-chip>
                </v-row>
              </v-col>
              <v-col cols="12" class="py-2">
                <v-row justify="space-between" align="center">
                  <span class="secondary--text font-weight-bold" cols="12">
                    Importe de anticipo:
                  </span>
                  <v-chip color="info">
                    {{ anticipo.importe | currency }}
                  </v-chip>
                </v-row>
              </v-col>
              <v-col cols="12" class="py-2">
                <v-row justify="space-between" aling="center">
                  <span class="secondary--text font-weight-bold" cols="12">
                    Porcentaje IVA:
                  </span>
                  <v-chip color="info">
                    {{ `${anticipo.porcentajeIva} %` }}
                  </v-chip>
                </v-row>
              </v-col>
              <v-col cols="12" class="py-2">
                <v-row justify="space-between" align="center">
                  <span class="secondary--text font-weight-bold" cols="12">
                    Importe IVA:
                  </span>
                  <v-chip color="info">
                    {{ anticipo.iva | currency }}
                  </v-chip>
                </v-row>
              </v-col>
              <v-col cols="12" class="py-2">
                <v-row justify="space-between" align="center">
                  <span class="secondary--text font-weight-bold" cols="12">
                    Importe Total:
                  </span>
                  <v-chip color="success">
                    {{ anticipo.total | currency }}
                  </v-chip>
                </v-row>
              </v-col>
            <v-row justify="center">
              <v-btn icon x-large class="mx-4" @click="borrar(anticipo)">
                <v-icon> mdi-delete </v-icon>
              </v-btn>
              <v-btn icon x-large class="mx-4" @click="editar(anticipo)">
                <v-icon> mdi-pencil </v-icon>
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </template>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoAnticiposContratoMobile',
  props: {
    listadoAnticipos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    editar(anticipoContrato) {
      eventBus.$emit('editar-anticipo-contrato', anticipoContrato);
    },
    borrar(anticipoContrato) {
      eventBus.$emit('eliminar-anticipo-contrato', anticipoContrato);
    },
  },
};
</script>

<style lang="scss"></style>
